export enum Status {
    NotInitialized = "NotInitialized",
    InProgress = "InProgress",
    Success = "Success",
    Error = "Error",
}
